import { ProductsService } from './products';

export async function findAll (): Promise<any> {
    return ProductsService.findAll();
}



// WEBPACK FOOTER //
// ./app/bundles/enterprise-shop/src/api/services/products/products.find-all.ts